import Http from '@/utils/http'
const baseUrl = '/app/teacher'

/**
 *章节列表
 * @param params
 * 
*/

export const mockUserList = params => Http.get(`${baseUrl}/chapter/mock`, { params })

export const mockBack = resultId => Http.put(`${baseUrl}/chapter/mock/${resultId}/repulse`)

export const getMockConfig = params => Http.get(`/app/mock/config/item`, { params })